(function () {
  var APIURL_V2 = 'https://aleli.appsinnovategroup.com/v2/';

  var EUR_COUNTRIES = [
    'AT','BE','CY','EE','FI','FR','DE','GR','IE','IT',
    'LV','LT','LU','MT','NL','PT','SK','SI','ES'
  ];

  var FLAG_MAP = {
    ARS: 'ar',
    USD: 'us',
    MXN: 'mx',
    EUR: 'european_union',
    GBP: 'gb'
  };

  function getPayPalCurrency(country) {
    if (country === 'MX') return 'MXN';
    if (country === 'GB') return 'GBP';
    if (EUR_COUNTRIES.indexOf(country) !== -1) return 'EUR';
    return 'USD';
  }

  async function fetchRate(to) {
    if (to === 'USD') return 1;
    var cacheKey = 'ig_rate_usd_' + to.toLowerCase();
    var cached = sessionStorage.getItem(cacheKey);
    if (cached) return parseFloat(cached);
    try {
      var resp = await fetch(APIURL_V2 + '?action=exchangeRate&to=' + to.toLowerCase());
      var data = await resp.json();
      if (data.rate) {
        sessionStorage.setItem(cacheKey, data.rate);
        return data.rate;
      }
    } catch (e) {
      console.error('Exchange rate fetch failed', e);
    }
    return 1;
  }

  function convertPrices(currency, rate) {
    document.querySelectorAll('[data-currency-usd] [data-usd-price]').forEach(function (el) {
      var usd = parseFloat(el.getAttribute('data-usd-price'));
      if (isNaN(usd)) return;
      if (currency === 'USD') {
        el.textContent = 'USD ' + usd.toFixed(2);
      } else {
        var converted = Math.ceil(usd * rate * 100) / 100;
        el.textContent = currency + ' ' + converted.toFixed(2);
      }
    });
  }

  function setPrice(currency) {
    var currencyUsd = document.querySelectorAll('[data-currency-usd]');
    var currencyArs = document.querySelectorAll('[data-currency-ars]');

    if (currency.toLowerCase() === 'ars') {
      currencyArs.forEach(function (el) { el.classList.remove('hide'); });
      currencyUsd.forEach(function (el) { el.classList.add('hide'); });
    } else {
      currencyArs.forEach(function (el) { el.classList.add('hide'); });
      currencyUsd.forEach(function (el) { el.classList.remove('hide'); });
    }
  }

  function updateActiveButton(selectedValue) {
    document.querySelectorAll('.currency-options__btn').forEach(function (btn) {
      if (btn.getAttribute('data-value') === selectedValue) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });
  }

  function updateHeaderFlag(currency) {
    var flagEl = document.getElementById('ig-header-currency-flag');
    if (!flagEl) return;
    var flagCode = FLAG_MAP[currency] || 'us';
    var classes = flagEl.className.replace(/currency-flag--\S+/, '');
    flagEl.className = classes.trim() + ' currency-flag--' + flagCode;
  }

  function updateDrawerMessages(currency) {
    var msgArs = document.querySelector('[data-currency-msg-ars]');
    var msgPaypal = document.querySelector('[data-currency-msg-paypal]');
    if (msgArs) msgArs.style.display = currency === 'ARS' ? 'block' : 'none';
    if (msgPaypal) msgPaypal.style.display = currency !== 'ARS' ? 'block' : 'none';
  }

  function revealPrices() {
    document.body.classList.add('currency-ready');
  }

  async function resolveAndApply(country) {
    var saved = localStorage.getItem('ig_selected_currency');
    var currency;

    if (saved && FLAG_MAP[saved]) {
      currency = saved;
    } else {
      currency = country === 'AR' ? 'ARS' : getPayPalCurrency(country);
    }

    if (currency !== 'ARS' && currency !== 'USD') {
      var rate = await fetchRate(currency);
      convertPrices(currency, rate);
    }

    setPrice(currency === 'ARS' ? 'ARS' : 'USD');
    updateActiveButton(currency);
    updateHeaderFlag(currency);
    updateDrawerMessages(currency);
    revealPrices();
  }

  async function getCountry() {
    try {
      var request = await fetch('https://ipinfo.io/json?token=40befa42e0b9e3');
      var result = await request.json();
      var currency = result.country === 'AR' ? 'ARS' : 'USD';
      localStorage.setItem('currency', currency);
      localStorage.setItem('ig_country', result.country);
      window.dispatchEvent(new CustomEvent('countryReady', { detail: result.country }));
      return result.country;
    } catch (error) {
      console.error(error);
      return '';
    }
  }

  document.addEventListener('DOMContentLoaded', async function () {
    var currencyOptions = document.querySelector('.currency-options');
    var currencyBtn = document.querySelector('.currency-picker__btn');

    document.querySelectorAll('[data-open-currency]').forEach(function (item) {
      item.addEventListener('click', function (evt) {
        evt.preventDefault();
        if (currencyBtn) currencyBtn.click();
      });
    });

    if (currencyOptions) {
      currencyOptions.addEventListener('click', async function (evt) {
        var btn = evt.target.closest('.currency-options__btn');
        if (!btn) return;
        var selected = btn.getAttribute('data-value');
        if (!selected) return;

        localStorage.setItem('ig_selected_currency', selected);
        localStorage.setItem('currency', selected === 'ARS' ? 'ARS' : 'USD');

        if (selected === 'ARS') {
          setPrice('ARS');
        } else {
          var rate = await fetchRate(selected);
          convertPrices(selected, rate);
          setPrice('USD');
        }

        updateActiveButton(selected);
        updateHeaderFlag(selected);
        updateDrawerMessages(selected);
        revealPrices();
      });
    }

    var country = localStorage.getItem('ig_country');
    if (!country) {
      country = await getCountry();
    }
    await resolveAndApply(country || '');
  });

  window.igCurrency = {
    getPayPalCurrency: getPayPalCurrency,
    fetchRate: fetchRate,
    convertPrices: convertPrices,
    EUR_COUNTRIES: EUR_COUNTRIES
  };
})();
